module.exports = __webpack_public_path__ + "static/media/ellipse.f95c1337.svg";